import clsx from "clsx";
import React, { LiHTMLAttributes, ReactNode } from "react";
import { Conditional } from "web/react/components/conditional";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { ResponsiveTextStyle } from "web/react/emo/sprinkles.css";
import { Text } from "web/react/emo/text";
import * as styles from "./list-item.css";

type ListChildItem = LiHTMLAttributes<HTMLLIElement> &
    ({ as: "a"; href: string } | { as?: "span"; href?: never } | { as: "button"; href?: string });

type ListItemWishLabel = {
    label: string;
    note?: string;
    children?: never;
};

type ListItemWishChildren = {
    label?: never;
    note?: never;
    children?: ReactNode;
};

export type ListItemProps = (ListItemWishLabel | ListItemWishChildren) &
    ListChildItem & {
        size?: keyof typeof styles.wrapper;
        variant?: keyof typeof styles.listItem;
        showChevron?: boolean;
        flexWrapperHeight?: boolean;
        textStyle?: ResponsiveTextStyle;
    };

export function ListItem({
    as: Component = "span",
    size = "sm",
    variant = "secondary",
    label,
    note,
    showChevron,
    children,
    href,
    className,
    flexWrapperHeight = false,
    textStyle = "body-1",
    ...props
}: ListItemProps): JSX.Element {
    return (
        <li {...props} className={clsx(styles.listItem[variant], className)}>
            <Component
                className={clsx(styles.wrapper[size], {
                    [styles.underline]: size === "lg" && !note,
                    [styles.flexibleHeight]: flexWrapperHeight,
                })}
                {...(href && { href })}
            >
                {children}
                <Text
                    as={"span"}
                    textStyle={textStyle}
                    color={"primary"}
                    className={styles.title}
                    truncate
                >
                    {label}
                </Text>
                <Conditional check={Boolean(note)}>
                    <Text as={"span"} textStyle={textStyle} color={"secondary"} truncate>
                        {`(${note})`}
                    </Text>
                </Conditional>
                <Conditional check={Boolean(showChevron)}>
                    <Text as={"span"} textStyle={textStyle} className={styles.iconWrapper}>
                        <SVGIcon name={"chevron-medium"} />
                    </Text>
                </Conditional>
            </Component>
        </li>
    );
}
